import * as amplitude from '@amplitude/analytics-browser';

import { trackEvent } from './track-event';

/**
 * Ключ, под которым помним, для какой пары «пользователь × сессия Amplitude» событие уже ушло.
 * `localStorage`, а не `sessionStorage`: сессия Amplitude общая для вкладок, и вторая вкладка
 * в той же сессии не должна давать второй старт.
 */
export const APPLICATION_OPENED_STORAGE_KEY = 'imgame:analytics:applicationOpened';

/**
 * Отправляет `Application Opened` — не чаще раза за сессию Amplitude на пользователя.
 *
 * Зачем дедупликация: шелл монтируется на каждый F5 и в каждой новой вкладке (а на дев-сервере
 * `StrictMode` ещё и вызывает эффекты дважды) — без неё один заход давал бы несколько стартов. Сессия Amplitude кончается после
 * 30 минут бездействия, поэтому «вернулся через час» — новый старт, а «нажал F5» — нет.
 *
 * Без `sessionId` (SDK не поднят: нет ключа или headless-роут) ничего не шлём — `track` там
 * всё равно ничего бы не отправил, а запомнить пустую сессию значило бы потерять настоящую.
 */
export function trackApplicationOpenedOnce(userId: string): void {
  const sessionId = amplitude.getSessionId();

  if (sessionId === undefined) {
    return;
  }

  const marker = `${userId}:${sessionId}`;

  if (readMarker() === marker) {
    return;
  }

  writeMarker(marker);
  trackEvent('Application Opened', {});
}

// Хранилище может бросить (приватный режим, запрет cookies) — тогда дедуплицировать нечем,
// и лишний старт лучше потерянного.
function readMarker(): string | null {
  try {
    return window.localStorage.getItem(APPLICATION_OPENED_STORAGE_KEY);
  } catch {
    return null;
  }
}

function writeMarker(marker: string): void {
  try {
    window.localStorage.setItem(APPLICATION_OPENED_STORAGE_KEY, marker);
  } catch {
    // см. комментарий выше
  }
}
